module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABEklEQVQ4T52Sv07DMBDGv3PSBYk/pc9ANzohWBBx8yw0bcUCvAAwIyExgCkwl5kgAVKlhjYLA48CNhJzzyhFDRBaCvF2Pv/83X13hJyHUi54mll03ipaVR+Hd9k4I5CC8/VoxRV0C+baS8u/HsUD0Oar8sJsYZ+KAEqN/iqIbxi8Y5TfLgXdNTgiZMa2acmrr/A3MEkUg96ycOy9BR1o5Z0Xm/2KAN9Z2D2tqpcj+AeYJObqvSVX2I4FToySh7NbcbnAgw6AY63kUfJmLPihHK0Lh2Ii+M+nMlpodj0H4oGBDaNk/DfFWlwuuFMUJ/Zosa/P5MXYHoeugkMm2jXKa6cu/+Zq/jnm3Zz/ruzEcUz76B1MjJAPQzsFYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/government_btn_more.png
// module id = sjTT
// module chunks = 1